import { Address, AddressType, Amount, CountryType, CurrencyType, StateType } from '@enter/core';
import { faker } from '@faker-js/faker';
import _ from 'lodash';
import { IItemListing } from './root.store';

interface IRequest {
    limit?: number;
    offset?: number;
}
export function generateItemListing<T>(request: IRequest, items: T[]): IItemListing<T> {
    // paginate results
    const offset = request.offset || 0; // default to 0
    const limit = request.limit || _.size(items) - offset; // default to (total - offset)
    const paginated = _.slice(items, offset, offset + limit);
    return {
        items: paginated,
        limit,
        offset,
        total: _.size(items),
    };
}

export function sortItems<T>(items: T[], sorts: string[] = [], orders: string[] = []): T[] {
    // sort results
    const sortCriteria = _.map(sorts, (sort: string) => _.toLower(sort));
    if (_.isEmpty(sortCriteria)) {
        sortCriteria.push('updated');
    }
    const orderCriteria = _.map(orders, order => (order === 'ASCENDING' ? 'asc' : 'desc'));
    if (_.isEmpty(orderCriteria)) {
        orderCriteria.push('desc');
    }
    return _.orderBy(items, sortCriteria, orderCriteria);
}

export function parseAmount(amount?: Amount): number {
    const f = parseFloat(_.get(amount, 'amount', '0'));
    return Number.isNaN(f) ? 0 : f;
}

export function generateAddress(): Address {
    return {
        name: _.sample(['Home', 'Work']) as string,
        lines: [faker.location.streetAddress()],
        city: faker.location.city(),
        state: oneOf(StateType),
        postal: faker.location.zipCode(),
        country: oneOf(CountryType),
        type: oneOf(AddressType),
    };
}

export function generateAmount(amount: number = _.random(1, 1000)): Amount {
    return {
        amount: String(amount),
        currency: CurrencyType.USD,
    };
}

export function eq(a?: string, b?: string): boolean {
    return !_.isEmpty(a) && !_.isEmpty(b) && _.toLower(a) === _.toLower(b);
}

export function like(a?: string, b?: string): boolean {
    return !_.isEmpty(a) && !_.isEmpty(b) && _.includes(_.toLower(a), _.toLower(b));
}

export function hasIdIn(arr?: string[]): (d: any) => boolean {
    return (d: any): boolean => _.includes(arr, d.id);
}

export function mapBy(model: any, field: string): string[] {
    return _.compact(_.map(model, field));
}

export function oneOf<T>(en: T): T[keyof T] {
    const key = _.sample(_.keys(en)) as string;
    return en[key as keyof T];
}

export function subsetOf<T>(en: T, n: number): T[keyof T][] {
    const pool = _.sampleSize(_.keys(en), n);
    return _.map(pool, k => en[k as keyof T]);
}

export function upToNTimes<T>(fn: (i?: number) => T, n: number = 1, s: number = 0): T[] {
    return _.uniq(_.times(_.random(s, n), fn));
}
